import { useState, useCallback, useEffect } from "react";

const STORAGE_KEY = "linguadeck-favorite-deck-ids";

function loadFavoriteDeckIds(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const parsed = JSON.parse(raw) as string[];
    return new Set(Array.isArray(parsed) ? parsed : []);
  } catch {
    return new Set();
  }
}

function saveFavoriteDeckIds(ids: Set<string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify([...ids]));
  } catch {
    // ignore
  }
}

export function useDeckFavorites() {
  const [favoriteDeckIds, setFavoriteDeckIds] = useState<Set<string>>(loadFavoriteDeckIds);

  useEffect(() => {
    setFavoriteDeckIds(loadFavoriteDeckIds());
  }, []);

  const toggleDeckFavorite = useCallback((deckId: string) => {
    setFavoriteDeckIds((prev) => {
      const next = new Set(prev);
      if (next.has(deckId)) {
        next.delete(deckId);
      } else {
        next.add(deckId);
      }
      saveFavoriteDeckIds(next);
      return next;
    });
  }, []);

  const isDeckFavorite = useCallback(
    (deckId: string) => favoriteDeckIds.has(deckId),
    [favoriteDeckIds]
  );

  return { isDeckFavorite, toggleDeckFavorite };
}
